export default __webpack_public_path__ + "static/media/Sofia-Pro-Light.4a146d1d.otf";